import { FiatFormDialog } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Deposit Fiat');
      },
      class: 'w-[30rem] h-[700px] bg-layer3_5-card',
    },
  },
};

export default FiatFormDialog;
